/**
 * Header breadcrumb parent rules — keep in sync with `meta.parent` in `router/routes.jsx`.
 * Ordered most-specific first (`matchPath` first win).
 */
export interface HeaderBreadcrumbRule {
  path: string;
  parentTo: string;
  parentLabelKey: string;
}

export const HEADER_BREADCRUMB_RULES: HeaderBreadcrumbRule[] = [
  { path: '/missions/create/:missionId', parentTo: '/missions', parentLabelKey: 'missions.title' },
  { path: '/missions/edit/:missionId', parentTo: '/missions', parentLabelKey: 'missions.title' },
  { path: '/missions/create', parentTo: '/missions', parentLabelKey: 'missions.title' },
  { path: '/missions/:missionId', parentTo: '/missions', parentLabelKey: 'missions.title' },
  { path: '/clients/:clientId', parentTo: '/clients', parentLabelKey: 'clients.title' },
  { path: '/freelancers/:id', parentTo: '/freelancers', parentLabelKey: 'freelancers.title' },
  { path: '/activity-report/view/:id', parentTo: '/activity-report', parentLabelKey: 'activityReport.headerSection' },
  { path: '/activity-report/create/:id', parentTo: '/activity-report', parentLabelKey: 'activityReport.headerSection' },
  { path: '/activity-report/create', parentTo: '/activity-report', parentLabelKey: 'activityReport.headerSection' },
  { path: '/templates/new', parentTo: '/settings?tab=template', parentLabelKey: 'settings.title' },
  { path: '/templates/:id', parentTo: '/settings?tab=template', parentLabelKey: 'settings.title' },
  { path: '/users/tag-management', parentTo: '/users', parentLabelKey: 'users.title' },
  { path: '/super-admin/blog/:postId', parentTo: '/super-admin/blog', parentLabelKey: 'superAdmin.blog.title' },
  {
    path: '/super-admin/templates/new',
    parentTo: '/super-admin/templates',
    parentLabelKey: 'superAdmin.templates.title',
  },
  {
    path: '/super-admin/templates/:id',
    parentTo: '/super-admin/templates',
    parentLabelKey: 'superAdmin.templates.title',
  },
  { path: '/onboarding/verify', parentTo: '/onboarding', parentLabelKey: 'onboarding.title' },
  { path: '/onboarding/freelancer', parentTo: '/onboarding', parentLabelKey: 'onboarding.title' },
];
